import AutoPaymentChooseScreen from 'features/advance/screens/registration/AutoPaymentScreen/AutoPaymentChooseScreen';
import React from 'react';

export default function AutoPaymentPage() {
  return <AutoPaymentChooseScreen />;
}
